import Message from 'common/components/Message';
import { IDENTITY_TYPE } from 'common/constants/Types';
import { TUpdateStore } from 'common/store/baseActions';
import Utils from 'common/utils';
import JSRuntime from 'common/utils/JSRuntime';
import { AuthnApi } from 'idpBase/http';
import { TGlobalStore } from 'idpBase/store';
import { FLOW_TYPE } from './constant';
import { IIdentity } from './type';
import { ssoRedirect } from './utils';
import { SSO_LOGIN_ERR_MSG } from '../constant';

class SSOLoginIdentityStore {
  public readonly global: TGlobalStore;
  public updateStore: TUpdateStore<SSOLoginIdentityStore>;
  public resetStore: () => void;

  /** 企业配置初始化数据加载状态 */
  public isLoading = true;
  /** 企业配置数据 */
  public domainData: Record<string, any> = {};
  /** 以顶部账号/密码显示的登录方式 */
  public delegationIdentities: IIdentity[] = [];
  /** 除了上面情况，其他的登录方式 */
  public redirectIdentities: IIdentity[] = [];
  /** 点击「更多方式」后，页面展示登录方式列表 */
  public showIdentitiesList = false;
  /** 当前选中的需要输入账号/密码的认证源 */
  public curDelegationIdentity: IIdentity;

  public async init() {
    if (JSRuntime.isCustomDomain || this.global.rootStore.accountId) {
      const res = await AuthnApi.loginByEmailOrDomain(
        JSRuntime.isCustomDomain
          ? { domainName: window.location.hostname }
          : { accountId: this.global.rootStore.accountId },
      );

      if (res.errCode) {
        const { errCode, errMessage } = res;
        // 不存在可用认证源时，不报错，展示空状态
        if (errCode !== 'E0010042') {
          Message.error(SSO_LOGIN_ERR_MSG[errCode] || errMessage);
          return;
        }
      }

      if (res.domain && !JSRuntime.isCustomDomain) {
        const configUrl = new URL(window.ONEID_PUBLIC_ORIGINAL_IDP_SITE);
        const { pathname, protocol, search } = window.location;
        const hash = Utils.getPureHashPath();

        Utils.safeRedirect(
          `${protocol}//${res.domain}.${configUrl.host}${pathname}${search}${
            hash.includes('#/sso_login/identity') ? hash : `${hash}/identity`
          }`,
        );
        return;
      }

      res.accountId && (await this.global.rootStore.getSettings({ accountId: res.accountId }));

      const delegationIdentities: IIdentity[] = [];
      const redirectIdentities: IIdentity[] = [];

      const idProviders = m.get(res.next, 'ssoOptions.idProviders', []);

      // 将账号密码登录方式放在第一个
      const pwdIndex = idProviders.findIndex((el) => el.uniqueName === IDENTITY_TYPE.PASSWORD);
      if (pwdIndex >= 0) {
        const pwdItem = idProviders[pwdIndex];
        idProviders.splice(pwdIndex, 1);
        idProviders.unshift(pwdItem);
      }

      idProviders.forEach((identity: IIdentity) => {
        if (identity.flowType === FLOW_TYPE.DELEGATION && delegationIdentities.length < 2) {
          delegationIdentities.push(identity);
        } else {
          redirectIdentities.push(identity);
        }
      });

      this.updateStore({
        isLoading: false,
        domainData: res,
        delegationIdentities,
        redirectIdentities,
      });
      return res;
    }
    // 优化不带企业域名的地址情况
    Utils.handleNoAuth();
  }

  public handleIdentityLogin = (identity: IIdentity) => {
    if (JSRuntime.isBrandDemoOrigin) return;
    if (identity.flowType === FLOW_TYPE.DELEGATION) {
      this.updateStore({
        curDelegationIdentity: identity,
      });
      return;
    }
    ssoRedirect(identity, this.domainData.accountId);
  };
}

export default SSOLoginIdentityStore;
